import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { RoleContextLabel } from './RoleContextLabel';

interface RoleCyclerButtonProps {
  roleContext: string;
  onRoleCycle?: () => void;
  roleKey?: string | number;
  children?: React.ReactNode;
}

const RoleCyclerButton: React.FC<RoleCyclerButtonProps> = ({
  roleContext,
  onRoleCycle,
  roleKey,
  children,
}) => {
  const hasChildren = children != null;

  const roleLabel = (
    <span className="font-label text-[10px] sm:text-[12px] leading-[10px] text-muted-foreground/50">
      Example using{' '}
      <RoleContextLabel text={roleContext} roleKey={onRoleCycle ? roleKey : undefined} />
    </span>
  );

  if (onRoleCycle) {
    return (
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => { e.stopPropagation(); onRoleCycle(); }}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); onRoleCycle(); } }}
        className={`flex ${hasChildren ? 'flex-col items-center gap-1' : 'items-center justify-center gap-2'} w-full min-h-11 rounded-[0.25rem] bg-foreground/[0.02] border border-border px-1 py-2 mb-2 cursor-pointer hover:bg-foreground/[0.06] hover:border-primary/20 motion-safe:transition-colors`}
      >
        {hasChildren ? (
          <div className="flex items-center gap-2">
            <ArrowLeft className="h-2.5 w-2.5 text-muted-foreground/35 shrink-0" strokeWidth={2.5} />
            {roleLabel}
            <ArrowRight className="h-2.5 w-2.5 text-muted-foreground/35 shrink-0" strokeWidth={2.5} />
          </div>
        ) : (
          <>
            <ArrowLeft className="h-2.5 w-2.5 text-muted-foreground/35 shrink-0" strokeWidth={2.5} />
            {roleLabel}
            <ArrowRight className="h-2.5 w-2.5 text-muted-foreground/35 shrink-0" strokeWidth={2.5} />
          </>
        )}
        {children}
      </span>
    );
  }

  return (
    <div className="flex items-center justify-center rounded-[0.25rem] bg-foreground/[0.02] border border-border px-2 py-2 mb-2">
      <span className="font-label text-[10px] sm:text-[12px] leading-none text-muted-foreground/50">
        Example using{' '}
        <RoleContextLabel text={roleContext} />
      </span>
      {children}
    </div>
  );
};

export { RoleCyclerButton };
export type { RoleCyclerButtonProps };
